"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionHighchartsSettingsFilterOvertimePeriodComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const use_custom_compare_1 = require("use-custom-compare");
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const CommonTypesI18N_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesI18N");
const dropdownItemRender = (text, key, selectedValues, enabled) => {
    const iconShow = lodash_1.default.includes(selectedValues, key) ? "visible" : "hidden";
    return { key: key, disabled: !enabled, label: React.createElement(antd_1.Row, null,
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemLabel" }, text),
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemSelectedIcon", flex: "auto", style: { visibility: iconShow } },
                React.createElement(icons_1.CheckOutlined, null))) };
};
const getMenuItemLabels = (periods, retentionType) => {
    const intervalName = CommonTypesI18N_1.CommonTypesI18N.retentionType.retentionTypeTypeToIntervalName(retentionType);
    return lodash_1.default.map(periods, (value) => {
        return [value, `${intervalName} ${value}`];
    });
};
const RetentionHighchartsSettingsFilterOvertimePeriodComponent = () => {
    var _a, _b, _c, _d;
    const retentionPageDataContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const { inProgress, loaded } = retentionPageDataContext.state.status;
    const { isError } = retentionPageDataContext.state.error;
    const chartHasNoData = ((_a = highchartsOptionsContext.state.chartStatus) === null || _a === void 0 ? void 0 : _a.status) === "noData";
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(retentionPageDataContext.state.data) || chartHasNoData;
    const request = (_b = retentionPageDataContext.state.data) === null || _b === void 0 ? void 0 : _b.request;
    const retentionType = (request === null || request === void 0 ? void 0 : request.retentionType) ? CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(request === null || request === void 0 ? void 0 : request.retentionType) : "nDay";
    const periods = Array.from(((_d = (_c = retentionPageDataContext.state.data) === null || _c === void 0 ? void 0 : _c.response) === null || _d === void 0 ? void 0 : _d.retentionPeriods) || []);
    const chartSettingsJSONModel = retentionPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
    const filterPeriod = chartSettingsJSONModel.getFilterPeriodByRetentionType(retentionType);
    if (!!process.env.IS_TEST_SERVER) {
        console.log("RetentionHighchartsSettingsFilterOvertimePeriodComponent: request", request);
    }
    // console.log("RetentionHighchartsSettingsFilterOvertimePeriodComponent: periods", periods);
    const [popupVisible, setPopupVisible] = (0, react_1.useState)(false);
    // console.log("highchartsOptionsContext.state.options.series", highchartsOptionsContext.state.options.series);
    const filterPeriodOnChange = (0, use_custom_compare_1.useCustomCompareCallback)((clickedMenuKey) => {
        const clickedMenuKeyAsNumber = lodash_1.default.toNumber(clickedMenuKey);
        if (lodash_1.default.isFinite(clickedMenuKeyAsNumber)) {
            const chartSettingsJSONModel = retentionPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
            const filterPeriod = lodash_1.default.cloneDeep(chartSettingsJSONModel.getFilterPeriodByRetentionType(retentionType));
            if (lodash_1.default.includes(filterPeriod, clickedMenuKeyAsNumber)) {
                lodash_1.default.remove(filterPeriod, e => e === clickedMenuKeyAsNumber);
            }
            else {
                filterPeriod.push(clickedMenuKeyAsNumber);
            }
            chartSettingsJSONModel.setFilterPeriodByRetentionType(filterPeriod, retentionType);
            retentionPageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
        }
    }, [retentionPageDataContext.stateFns, retentionType], lodash_1.default.isEqual);
    const onClickMenu = (0, react_1.useCallback)(({ key }) => {
        filterPeriodOnChange(key);
    }, [filterPeriodOnChange]);
    const dropdownRender = (0, react_1.useCallback)((periods, filterPeriod, retentionType) => {
        const periodIndexesWithSignificantDataPoints = lodash_1.default.mapKeys(lodash_1.default.map(highchartsOptionsContext.state.options.series, series => {
            var _a, _b;
            if ((_a = series.custom) === null || _a === void 0 ? void 0 : _a.hasAtLeastOneSignificantDataPoint) {
                return (_b = series.custom) === null || _b === void 0 ? void 0 : _b.periodIndex;
            }
            return -1;
        }));
        //selected values are sorted and then filtered to contain only items with data points
        const selectedValues = lodash_1.default.sortBy(filterPeriod);
        // const selectedValues: SelectedValues = _.filter(_.sortBy(filterPeriod), value => !_.isNil(periodIndexesWithSignificantDataPoints[value]))
        const selectedValuesStrings = lodash_1.default.map(selectedValues, lodash_1.default.toString);
        const selectOptionsLabels = getMenuItemLabels(periods, retentionType);
        const items = selectOptionsLabels.map((value, i) => {
            /**
             * here we try to find if there is a chart series with corresponding day shift index
             * this logic will disable menu items which would display no data on highcharts
             */
            const found = !lodash_1.default.isNil(periodIndexesWithSignificantDataPoints[i]);
            return dropdownItemRender(React.createElement(React.Fragment, null, value[1]), value[0], selectedValues, found);
        });
        return React.createElement(antd_1.Menu, { multiple: true, className: "multiSelectDropdown multiSelectDropdownComponent", selectedKeys: selectedValuesStrings, onClick: onClickMenu, items: items });
    }, [onClickMenu, highchartsOptionsContext]);
    const onPopupVisibleChange = (popupVisible) => setPopupVisible(popupVisible);
    const overlay = dropdownRender(periods, filterPeriod, retentionType);
    const isActive = !(0, RetentionChartSettingsJSONModel_1.isDefaultFilterPeriod)(filterPeriod, retentionType);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Dropdown, { overlay: overlay, disabled: disabled, placement: "bottomRight", trigger: ["click"], className: `appMultiSelectComponent${popupVisible ? " appMultiSelectComponentActive" : ""}`, visible: popupVisible, onVisibleChange: onPopupVisibleChange },
            React.createElement(antd_1.Button, { icon: React.createElement(icons_1.FilterOutlined, null), disabled: disabled, type: isActive ? "primary" : "default" })));
};
exports.RetentionHighchartsSettingsFilterOvertimePeriodComponent = RetentionHighchartsSettingsFilterOvertimePeriodComponent;
